// extracted by mini-css-extract-plugin
export var acitonButtons = "_hd-0";
export var additionalIcon = "_hd-f";
export var block = "_hd-1";
export var blockContent = "_hd-7";
export var blockDescription = "_hd-8";
export var blockIcon = "_hd-9";
export var blockTitle = "_hd-6";
export var border = "_hd-a";
export var center = "_hd-l";
export var edge = "_hd-b";
export var edgeLabel = "_hd-c";
export var edgePath = "_hd-d";
export var error = "_hd-e";
export var flowchart = "_hd-g";
export var flowchartContent = "_hd-h";
export var highlighted = "_hd-3";
export var hover = "_hd-4";
export var icon = "_hd-i";
export var left = "_hd-m";
export var navButton = "_hd-j";
export var navButtons = "_hd-k";
export var right = "_hd-n";
export var selected = "_hd-2";
export var small = "_hd-5";